import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { getFirstItem } from 'lib/util'
import Icon from 'ui/Element/Icon'

const styles = () => ({
  icon: {
    width: '3rem',
    minHeight: '3rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

/**
 * Displays the icon of an organisation.
 *
 * @param {Object} classes  styles for the component
 * @param {Object} props    props for the component
 * @returns {JSX.Element}
 */
const ListItemCellDashboardOrganisationIcon = (classes, props = {}) => {
  const { events, type: typeKey } = props
  const { icon = 'factory' } = getFirstItem(events?.getOrganisationType?.(typeKey) || [{}])

  return (
    <Grid
      item
      xs={'auto'}
      className={classes.icon}
    >
      <Icon
        size={32}
        source={icon}
        rounded={true}
        padding={'0.5rem'}
        color={'primary.main'}
        background={'gray.960'}
      />
    </Grid>
  )
}

export default CellHOC(ListItemCellDashboardOrganisationIcon, styles)
